<div class="container pt-3 fade-in-left">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Mis Turnos</h1></div>
        <div class="p-2 pl-2 help" (click)="toggleHelp()"><i class="bi bi-info-circle"></i></div>
    </div>
    @if (helpVisible()) {
        <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
            <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
            <div class="col">{{ helpText() }}</div>
            <div class="col-auto" (click)="toggleHelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
        </div>
    }
 
    <!-- Sections -->
     @if(!id_estado_orden){
        <div class="row-cols-12 m-2 mb-3">
            <div class="text-p p-3 pb-1">
                <button class="btn btn-primary btn-lg mt-0 mb-3" [routerLink]="['/especialidad']">Solicitar nuevo turno</button>
            </div>

            <div class="text-p p-3 pb-1">
                <h2>Próximos turnos</h2>
            </div>
            @for (ordenPrestadorProximo of ordenesPrestadorProximos; track ordenPrestadorProximo.id) {
                <a [routerLink]="(ordenPrestadorProximo.id_estado_orden == 1 && id_perfil == 3) ? ['/order-response-prestador/', ordenPrestadorProximo.id] : ordenPrestadorProximo.id_estado_orden == 2 ? ['/order-confirm-prestador/', ordenPrestadorProximo.id_solicitud] : ['/order-detail-prestador/', ordenPrestadorProximo.id]">
                    <div class="row p-2 px-4 align-items-center">
                        <div class="col-auto"><i class="bi bi-calendar"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">
                                {{
                                    ordenPrestadorProximo.d_fecha_turno
                                    ? (ordenPrestadorProximo.d_fecha_turno | date: 'dd/MM/yyyy - HH:mm') + 'hs'
                                    : 'Horario a confirmar'
                                }}
                            </div>
                            <div class="col-12 text-detail-item">
                                {{
                                    ordenPrestadorProximo.nombreEspecialidad
                                    ? ordenPrestadorProximo.nombreEspecialidad
                                    : ordenPrestadorProximo.nombrePrestador
                                }}
                            </div>
                            <div class="col-12 text-detail-item">{{ordenPrestadorProximo.estadoOrden}} #{{ordenPrestadorProximo.id}}</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
        </div>

        <div class="row-cols-12 m-2 mb-3" >
            <div class="text-p p-3 pb-1">
                <h2>Turnos anteriores</h2>
            </div>
            @for (ordenPrestadorAnterior of ordenesPrestadorAnteriores; track ordenPrestadorAnterior.id) {
                <a [routerLink]="['/order-detail-prestador/', ordenPrestadorAnterior.id]">
                    <div class="row p-2 px-4 align-items-center">
                        <div class="col-auto"><i class="bi bi-calendar"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">{{ordenPrestadorAnterior.d_fecha_turno | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                            <div class="col-12 text-detail-item">
                                {{
                                    ordenPrestadorAnterior.nombreEspecialidad
                                    ? ordenPrestadorAnterior.nombreEspecialidad
                                    : ordenPrestadorAnterior.nombrePrestador
                                }}
                            </div>
                            <div class="col-12 text-detail-item">{{ordenPrestadorAnterior.estadoOrden}} #{{ordenPrestadorAnterior.id}}</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
            <div class="p-5"></div>
        </div>
    }
    
    @if(id_estado_orden === 4){
        <div class="row-cols-12 m-2 mb-3">
            <div class="text-p p-3 pb-1">
                <h2>Turnos a calificar</h2>
            </div>
            @for (ordenPrestadorFiltrada of ordenesPrestadorFiltradas; track ordenPrestadorFiltrada.id) {
                <a [routerLink]="['/review-prestador/', ordenPrestadorFiltrada.id]">
                    <div class="row p-2 px-4 align-items-center" [ngClass]="{'text-danger': ordenPrestadorFiltrada.id_estado_orden == 5}">
                        <div class="col-auto"><i class="bi bi-calendar"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">{{ordenPrestadorFiltrada.d_fecha_turno | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                            <div class="col-12 text-detail-item">{{ordenPrestadorFiltrada.nombreEspecialidad}}</div>
                            <div class="col-12 text-detail-item">{{ordenPrestadorFiltrada.estadoOrden}} #{{ordenPrestadorFiltrada.id}}</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
            <div class="p-5"></div>
        </div>
    }
</div>